<div class="machine-card" [ngClass]="{ 'cursor-pointer': !canRedirect() }" (click)="redirectDashboardDyeingDetails(stateMachine().assetId)">
  <div class="header">
    <div class="flex items-center gap-2">
      <p class="bg-black text-white font-semibold p-1 rounded max-w-max">{{ stateMachine().assetId }}</p>
    </div>

    @if (machineStatus() == DyeingMachineStatus.Unloading) {
      @switch (stateMachine().currentDyeingCycle?.colorStatusApproval?.isApproved) {
        @case (true) {
          <p class="rounded-lg p-3 text-center bg-[#DCFCE7] text-[#15803D] font-bold">Approved</p>
        }
        @case (false) {
          <p class="rounded-lg p-3 text-center bg-[#FFEDD5] text-[#C2410C] font-bold">Rejected</p>
        }
      }
    } @else if (machineStatus() == DyeingMachineStatus.AwaitingQA) {
      <p class="rounded-lg p-3 text-center bg-[#F1F5F9] text-[#475569] font-bold">Pending</p>
    }
    <p>{{ currentProductionCard()?.productionCardNumber }}</p>
  </div>
  <div class="body">
    <div class="grid-2 py-5">
      @if (stateMachine()) {
        @if (stateMachine().currentProductionCard) {
          <div class="span-1">
            <p class="text-gray-400">{{ 'DyeingCardMachine.Client' | translateWF: 'Client' }}</p>
            <p class="text-black font-semibold">{{ stateMachine().currentWorkOrder?.customer?.name }}</p>
          </div>
          <div class="span-1">
            <p class="text-gray-400">{{ 'DyeingCardMachine.Brand' | translateWF: 'Brand' }}</p>
            <p class="text-black font-semibold">{{ stateMachine().currentWorkOrder?.brand?.name }}</p>
          </div>
          <div class="span-1">
            <p class="text-gray-400">{{ 'DyeingCardMachine.ClientPO' | translateWF: 'Client PO' }}</p>
            <p class="text-black font-semibold">{{ clientPO }}</p>
          </div>
          <div class="span-1">
            <p class="text-gray-400">{{ 'DyeingCardMachine.WorkOrder' | translateWF: 'Work Order' }}</p>
            <p class="text-black font-semibold">
              {{ currentWorkOrder()?.orderNumber }}
            </p>
          </div>
        } @else {
          <div class="span-2 text-center">
            <p class="text-gray-400 font-semibold">
              {{ 'DyeingCardMachine.NoProductionCardAssigned' | translateWF: 'Not Production card Assigned ' }}
            </p>
          </div>
        }
      }
    </div>
    <!-- Cycle Information -->
    @if (stateMachine().currentDyeingCycle) {
      <div class="cycle-info bg-blue-50 px-3 py-2 rounded-md mb-3">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-2">
            <i class="pi pi-sync text-blue-600 text-sm"></i>
            <span class="text-sm font-semibold text-blue-800">Cycle #{{ stateMachine().currentDyeingCycle!.cycleNumber }}</span>
          </div>
          @if (isFirstRun()) {
            <span class="text-xs bg-orange-100 text-orange-700 px-2 py-0.5 rounded font-medium"> <i class="pi pi-flag text-orange-600"></i> First </span>
          }
        </div>
        <p class="text-xs text-blue-600 mt-1">{{ stateMachine().currentDyeingCycle!.number }}</p>
      </div>
    }
    <!-- First Run Badge -->
    @if (showFirstRunBadge()) {
      <div class="first-run-badge bg-orange-500 text-white px-3 py-2 rounded-md flex items-center gap-2 mb-3">
        <i class="pi pi-exclamation-triangle text-white"></i>
        <span class="text-sm font-semibold">First Production card from {{ currentWorkOrder()?.orderNumber ? currentWorkOrder()?.orderNumber : 'this Work Order' }}!</span>
      </div>
    }
    <!-- Timers Section -->
    @if (showCycleTimer() || showWaitingTimer()) {
      <div class="timers-section flex gap-4 py-4">
        @if (showCycleTimer()) {
          <div class="timer-item flex items-center gap-2 bg-white px-4 py-2 rounded-lg border border-gray-200">
            <div class="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-green-600" viewBox="0 0 20 20" fill="currentColor">
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
            <span class="text-lg font-semibold text-gray-800">{{ cycleElapsedTime() }}</span>
          </div>
        }

        @if (showWaitingTimer()) {
          <div class="timer-item flex items-center gap-2 bg-white px-4 py-2 rounded-lg border border-gray-200">
            <div class="w-8 h-8 rounded-full bg-orange-100 flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-orange-600" viewBox="0 0 20 20" fill="currentColor">
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
            <span class="text-lg font-semibold text-gray-800">{{ waitingElapsedTime() }}</span>
          </div>
        }
      </div>
    }
  </div>

  <div class="footer">
    @switch (machineStatus()) {
      @case (DyeingMachineStatus.Running) {
        <p class="w-full rounded-lg p-3 text-center bg-[#DCFCE7] text-[#15803D] font-bold">
          {{ 'DyeingCardMachine.Running' | translateWF: 'Running' }}
        </p>
      }
      @case (DyeingMachineStatus.AwaitingQA) {
        <p class="w-full rounded-lg p-3 text-center bg-[#E9E0FF] text-[#6750A4] font-bold">
          {{ 'DyeingCardMachine.AwaitingQA' | translateWF: 'Awaiting QA' }}
        </p>
      }
      @case (DyeingMachineStatus.Unloading) {
        <p class="w-full rounded-lg p-3 text-center bg-[#FFEDD5] text-[#C2410C] font-bold">
          {{ 'DyeingCardMachine.Unloading' | translateWF: 'Unloading' }}
        </p>
      }
      @default {
        <p class="w-full rounded-lg p-3 text-center bg-[#F1F5F9] text-[#475569] font-bold">
          {{ 'DyeingCardMachine.StandBy' | translateWF: 'Stand By' }}
        </p>
      }
    }
  </div>
</div>
